<div class="row">
  <div class="col-12">
    <lib-gung-number-input [gungTranslate]="'Font Size'" [ngModel]="fontSize" (input)="onFontSizeChange($event)"></lib-gung-number-input>
  </div>
  <div class="col-12">
    <div class="d-flex color-dp-input">
      <lib-gung-text-input [gungTranslate]="'Color'" [ngModel]="color" (input)="onColorChange($event)"></lib-gung-text-input>
      <input class="input-color" type="color" [(ngModel)]="color" (input)="onColorChange($event)" />
    </div>
    <div class="d-flex mt-2">
      <button
        class="btn btn-sm btn-outline-secondary"
        [class.align-active]="align=== 'left'"
        (click)="onAlignChange('left')"
      >
        <i class="fa-solid fa-align-left"></i>
      </button>
      <button
        class="btn btn-sm btn-outline-secondary"
        [class.align-active]="align === 'center'"
        (click)="onAlignChange('center')"
      >
        <i class="fa-solid fa-align-center"></i>
      </button>
      <button
        class="btn btn-sm btn-outline-secondary"
        [class.align-active]="align === 'right'"
        (click)="onAlignChange('right')"
      >
        <i class="fa-solid fa-align-right"></i>
      </button>
    </div>
  </div>
</div>
